type Params = {
  email: string;
  password: string;
};

export default function httpCreateJSONWebToken(
  params: Params,
): Promise<string> {
  return fetch('iam/createJSONWebToken', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(params),
  }).then((response) => {
    if (response.ok) {
      return response.json();
    } else {
      return response.text().then((message) => {
        throw new Error(message);
      });
    }
  });
}
